import actions from '@/core/store/item-ata/aditamento/historico/actions'
import state from '@/core/store/item-ata/aditamento/historico/state'
import mutations from '@/core/store/item-ata/aditamento/historico/mutations'

export default { actions, state, mutations }
